<template>
    <div class="page_czj flex-col">
        <div class="block_54 flex-col">

            <div class="group_70 flex-col">
                <div class="text-group_231 flex-col justify-between">
                    <span class="text_199">为什么选择我们</span>
                    <span class="text_200">CORE STRENGTH</span>
                </div>
                <div class="group_108 flex-row justify-between">
                    <div class="group_109 flex-col">
                        <div
                                v-for="(item, index) in items"
                                :key="index"
                                class="flex-row"
                                :class="activeIndex === index ? (index === 0 ? 'section_33_hover_first' : 'section_33_hover')
      : 'section_33'"
                                @click="handleSelectIndex(index)"
                                @mouseover="hoverIndexFun(index) "
                                @mouseleave="offhoverIndexFun"
                        >
                            <img class="label_11" :src="item.icon" />
                            <span :class="['text', activeIndex === index ? 'text_201' : 'text_202']">
                {{ item.text }}
              </span>
                        </div>
                    </div>
                    <div class="group_73 flex-col">
                        <img
                                class="image_37"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_core_select02.png"
                        />
                        <div class="image-text_195 flex-row justify-between">
                            <img
                                    class="thumbnail_9"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/home/chpc_about_industry_02.png"
                            />
                            <transition name="fade" mode="out-in">
                <span class="text-group_147" :key="activeIndex">
                  {{ items[activeIndex].content }}
                </span>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectedIndex:0,
                hoverIndex:-1,
                activeIndex: 0, // 当前激活的条目索引
                items: [
                    {
                        icon: require('../../../assets/home/chpc_about_industry_03.png'),
                        text: '全场景覆盖能力',
                        content:'深度渗透学协会、基金会、及CSO组织等高风险环节，提供涵盖费用审核（包含T&E、市场推广费用、对公第三方等）、三方会议资料核查、终端可疑商户走访、尽职调查（DD）等维度的30+专项服务，精准识别业务的合理性、合规性及企业制度遵从性。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_04.png'),
                        text: '全链路穿透式稽查',
                        content:'服务覆盖“事前-事中-事后”全流程，通过多维度联动核查，精准识别业务链条中的矛盾点与潜在合规风险，为企业保驾护航。例如：针对学术会议，从活动申请、执行、关会到报账进行穿透式核查，核实活动合规性、真实性，以及政策遵从性。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_05.png'),
                        text: '高度定制化核查服务',
                        content:'基于近二十年合规管理服务经验，能够依据政策变化与最新行业趋势，及时甄别客户业务风险；按需求定制核查范围、深度与周期，提供灵活适配的合规解决方案。例如：针对区域监管差异，定向设计突击检查方案；针对创新业务模式开发专属风险指标库，精准匹配企业战略目标。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_06.png'),
                        text: '智能化合规工具',
                        content:'自主研发AI智能识别系统高效处理大量底稿、票据等资料；采用智能化项目执行管理、人员排期合理分配人力资源；提升查验效率和精准度；提升风险预警能力。',
                    }
                ],
                constants: {}
            };
        },
        methods: {
            handleSelectIndex(index){
                this.activeIndex = index;
                this.selectedIndex = index;
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.activeIndex = index;
            },
            offhoverIndexFun(){
                //this.activeIndex = this.selectedIndex ;
                //this.hoverIndex = -1;
            },
        }
    };
</script>
<style scoped lang="css"  >
    .page_czj {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 1468px;
        overflow: hidden;
    }

    .block_54 {
        position: relative;
        width: 1468px;
        margin-bottom: 1px;
        align-items: center;
    }

    .group_70 {
        background-color: rgba(255, 255, 255, 1);
        width: 1200px;
        height: 600px;
        align-items: center;
    }

    .text-group_231 {
        width: 100%;
        height: 96px;
        margin: 50px 0 0 0;
        align-items: center;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_199 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_200 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
    }

    .group_108 {
        width: 1105px;
        height: 355px;
        margin: 39px 0 60px 0;
    }

    .group_109 {
        width: 520px;
        height: 355px;
        gap: 28px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .section_33_hover {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 510px;
        height: 69px;
        margin: 0 0 0 1px;
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }
    .section_33_hover_first {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 510px;
        height: 69px;
        margin: 0 0 0 1px; /* 去除上边距 */
        transition: all 0.3s;
        cursor: pointer;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_33 {
        border-radius: 4px;
        width: 510px;
        height: 69px;
        border: 1px solid rgba(232, 232, 232, 1);
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }

    .label_11 {
        width: 22px;
        height: 24px;
        margin: 20px 0 0 25px;
    }

    .text_201 {
        width: 382px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(0, 120, 126, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 19px 64px 0 27px;
    }
    .text_202 {
        width: 360px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 20px 77px 0 26px;
    }



    .group_73 {
        box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 1);
        width: 548px;
        height: 351px;
    }

    .image_37 {
        width: 550px;
        height: 120px;
        margin-left: -1px;
    }

    .image-text_195 {
        width: 501px;
        height: 180px;
        margin: 20px 0 31px 12px;
    }

    .thumbnail_9 {
        width: 12px;
        height: 14px;
        margin-top: 8px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .text-group_147 {
        width: 478px;
        height: 180px;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 30px;
    }

</style>
